import { PropertyMetaData } from './property-meta-data';
import { EnumResource } from './enum-resource';
import { Expose, Type } from '@nts/std/serialization';
import type { EnumMetaDataInterface, EnumResourceInterface } from '@nts/std/interfaces';

/**
 * Metadati relativi a proeprty di tipo enum
 */
export class EnumMetaData<T = number> extends PropertyMetaData implements EnumMetaDataInterface<T> {

    static TYPE = 'Enum';
    protected override _type = EnumMetaData.TYPE;

    /**
     *  Elenco dei valori dell'enum associati alle relative chiavi per recuperare le descrizioni dalle risorse
     */
    @Expose()
    @Type(() => EnumResource)
    valuesResource: EnumResourceInterface<T>[];

    /**
     * Costruttore di default
     */
    constructor() {
        super();
    }

    override set(data: any) {
        super.set(data);
        if (data?.valuesResource != null) {
            this.valuesResource = data.valuesResource;
        }
    }

    // TODO Tommy: verificare il serializzatore se gestisce corettamente l'enum
}
